import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'
import { Modal } from 'react-bootstrap'

// Import menuDropdown
import LanguageDropdown from "../../LanguageDropdown";
import ThemeToggle from "../../ThemeToggle";
import { clearTemporaryStorage, formatMoney } from 'helpers/helpers'

import { TOGGLE_LEFT_MENU } from "store/layout/actions";
import { GET, httpOk } from "helpers/api";
import { SET_SETTINGS } from "store/settings/actions";

function Header() {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const dispatch = useDispatch()

	const wrapperRef = useRef(null);
	useOutsideAlerter(wrapperRef);

	const layoutSelector = useSelector(state => state.layout)
	const reduxAccount = useSelector(state => state.account)
	const reduxSettings = useSelector(state => state.settings)

	const pos = 0
	const [modalLogout, setModalLogout] = useState(false)
	const [showUserDropdown, setShowUserDropdown] = useState(false)

	function tToggle() {
		if (layoutSelector.showleftMenu) {
			dispatch(TOGGLE_LEFT_MENU(false));
		} else {
			dispatch(TOGGLE_LEFT_MENU(true));
		}
	}

	async function getCurrentCurrency() {
		const response = await GET('/current-currency')
		if (httpOk(response)) {
			dispatch(SET_SETTINGS({ currency: response.data }))
		}
	}

	async function logout() {
		dispatch({ 'type': 'USER_LOGGED_OUT', payload: null })
		clearTemporaryStorage()
		navigate('/auth/login')
	}

	useEffect(() => {
		getCurrentCurrency();
	}, []) // eslint-disable-line react-hooks/exhaustive-deps


	function useOutsideAlerter(ref) {
		useEffect(() => {
			function handleClickOutside(event) {
				if (ref.current && !ref.current.contains(event.target)) {
					setShowUserDropdown(false)
				}
			}
			document.addEventListener("mousedown", handleClickOutside);
			return () => {
				document.removeEventListener("mousedown", handleClickOutside);
			};
		}, [ref]);
	}

	return (
		<>
			<header id="page-topbar" className={layoutSelector.showleftMenu ? 'sidebar-active-left' : 'sidebar-left'}>
				<div className="navbar-header">
					<div className="d-flex">
						<button type="button" id="vertical-menu-btn"
							className="btn btn-sm px-3 header-item waves-effect vertical-menu-btn"
							onClick={() => tToggle()}>
							<i className="uil-bars fz-20" />
						</button>
					</div>

					<div className="d-flex align-items-center gap-2">
						<Link to="/currency" className="alert mb-0" role="alert" style={{ height: '40px' }}>
							{t('rate')} = {formatMoney(reduxSettings.currency)}
						</Link>


						<Link to="/cashbox" className="btn btn-primary" style={{ height: '40px' }}>
							{t('cashbox')}
						</Link>

						<ThemeToggle />
						<LanguageDropdown />

						<div className="d-lg-inline-block dropdown" >
							<button type="button" className="btn header-item noti-icon waves-effect" ref={wrapperRef}>
								<div className={`profile-dropdown ${pos?.balance < 0 && 'bounce-effect'}`}>
									<div className={`profile-dropdown-toggle ${(pos?.balance > 0 ? 'success' : 'danger')}`}
										onClick={() => setShowUserDropdown(!showUserDropdown)}>
										<i className="uil uil-user" color="#fff"></i>
									</div>
									{showUserDropdown &&
										<div className="profile-dropdown-menu">
											<div className="profile-dropdown-item">
												<div>{t('name')}:</div>
												<div>{reduxAccount.name}</div>
											</div>
											<div className="profile-dropdown-item">
												<div>{t('login')}:</div>
												<div>{reduxAccount.login}</div>
											</div>
											<div className="profile-dropdown-item">
												<div>ID:</div>
												<div>{reduxAccount.id}</div>
											</div>
											<div className="profile-dropdown-item">
												<div>{t('balance')}:</div>
												<b className={`${pos?.balance < 0 && 'text-danger'}`}>
													{formatMoney(pos?.balance)}
												</b>
											</div>
											<div className="profile-dropdown-item second d-none"
												onClick={() => {
													navigate('/payment')
													setShowUserDropdown(false)
												}}>
												{t('payment')}
												<i className="uil-transaction"></i>
											</div>
											<div className="profile-dropdown-item second"
												onClick={() => setModalLogout(true)}>
												<div>
													{t('logout')}
												</div>
												<i className="uil-signin"></i>
											</div>
										</div>
									}
								</div>
							</button>
						</div>
					</div>
				</div>
			</header>

			<Modal show={modalLogout} animation={false}
				centered dialogClassName="update-modal-width" backdrop="static"
				onHide={() => setModalLogout(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('logout')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{t('are_you_sure_you_want_logout')}
				</Modal.Body>
				<Modal.Footer >
					<div className="d-flex gap-2 w-100">
						<button className="btn btn-warning w-100"
							onClick={() => setModalLogout(false)}>
							{t('cancel')}
						</button>
						<button className="btn btn-primary w-100"
							onClick={() => logout()}>
							{t('confirm')}
						</button>
					</div>
				</Modal.Footer>
			</Modal>
		</>
	);
};

export default Header
